<template>
  <async-loader v-if="cloudCannonContentLoading"/>
  <div class="terms-wrapper _mbs" v-else>
    <cloud-cannon-content
      class="_p0 bg-light-gray"
      :content="cloudCannonContent.content"
      :content-loading="cloudCannonContentLoading"
    />
  </div>
</template>

<script>
  import fetchable from '@mixins/fetchable'
  import CloudCannonable from '@mixins/CloudCannonable'
  import AsyncLoader from '@molecules/AsyncLoader'

  export default {
    mixins: [ fetchable, CloudCannonable ],
    components: {
      AsyncLoader
    },
    data () {
      return {
        fetchers: [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/terms.json'
            },
            config: {
              root: true
            }
          }
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
  .terms-wrapper {
    border: 1px solid $color-border;
    max-height: 15rem;
    height: 15rem;
    overflow-y: scroll;

    >:first-child {
      padding: 2rem;
    }
  }
</style>
